import React from 'react';

interface ArticleReferencesListProps {
  references: Record<string, string>;
}

export const ArticleReferencesList: React.FC<ArticleReferencesListProps> = ({ references }) => {
  if (!references || Object.keys(references).length === 0) {
    return null;
  }

  return (
    <div className="mt-4 pt-4 border-t border-gray-500">
      <h5 className="text-sm font-semibold text-[#CECFD2] mb-3">
        Referenced Articles
      </h5>
      <div className="bg-[#1A1A1A] rounded-lg p-4 border border-gray-500">
        <div className="space-y-3">
          {Object.entries(references).map(([title, url], index) => (
            <div key={index} className="flex items-start gap-3">
              <span className="text-[#3d37cc] mt-0.5 text-sm">•</span>
              <a 
                href={url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-[#3d37cc] hover:text-[#4E46FF] hover:underline break-words transition-colors"
              >
                {title}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};